import { Component, OnInit } from "@angular/core";
import saveAs from "file-saver";
import { Observable } from "rxjs";
import { SnackbarService } from "src/app/core/service/snackbar.service";
import { UsuarioTO } from "src/app/data/schema/User/UsuarioTO";
import { ApiDownloadService } from "src/app/data/service/download/download.service";
import { ProfileService } from "../../services/profile.service";

@Component({
    selector: "app-profile-documents",
    templateUrl: "./profile-documents.component.html",
    styleUrls: ["./profile-documents.component.scss"]
})
export class ProfileDocumentsComponent implements OnInit {
    public user$: Observable<UsuarioTO>;
    public isLoading$: Observable<boolean>;

    constructor(
        private profileService: ProfileService,
        private downloadService: ApiDownloadService,
        private snackBar: SnackbarService
    ) {}

    ngOnInit() {
        this.isLoading$ = this.profileService.getLoadingAsync();

        this.profileService.getLoggedUser();

        this.user$ = this.profileService.getUserAsync();
    }

    public download(url: string, name: string): void {
        this.downloadService.download(url).subscribe(
            (response) => {
                if (response) {
                    saveAs(new Blob([response.slice(0)]), name);
                }
            },
            (error) => {
                console.log(error);
                this.snackBar.showHttpMessage(error.code, error.message);
            }
        );
    }
}
